<template>
  <div class="step" :style="{ background: siteSettings.background }">
    <QuestionHeading :text="questionObject.question" />
    <ListWrapper>
      <template>
        <Answer
          v-for="(answer, index) in questionObject.answers"
          :answer="answer"
          :selected="multiAnswersIds.includes(index)"
          @onAnsweredQuestion="answeredQuestion"
          :key="index"
          :index="index"
          :mode="questionObject.mode"
          :class="
            Array.isArray(questionObject.answers)
              ? `num-questions-${questionObject.answers.length}`
              : `num-questions-${Object.keys(questionObject.answers).length}`
          "
        />
      </template>
    </ListWrapper>
    <button
     v-if="questionObject.type === 'multi' || !questionObject.required"
      @click="storeAnswers"
    >
       <span> Next </span>
        <font-awesome-icon
      :icon="doneIcon"
      
      class="doneIcon"
    />
      </button>
    
    <Debug />
  </div>
</template>

<script>
import QuestionHeading from "./Heading.vue";
import ListWrapper from "./ListWrapper.vue";
import Answer from "./Answer.vue";
import Debug from "./Debug.vue";
import { mapActions, mapState } from "vuex";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faArrowCircleRight as fasArrowCircleRight } from "@fortawesome/free-solid-svg-icons/faArrowCircleRight";
export default {
  name: "QuestionStep",
  props: {
    questionObject: {
      type: Object,
      required: true
    }
  },
  components: {
    QuestionHeading,
    ListWrapper,
    Answer,
    Debug,
    FontAwesomeIcon
  },
  data() {
    return {
      multiAnswers: [],
      doneIcon: fasArrowCircleRight
    };
  },
  computed: {
    ...mapState([
      "siteSettings",
      "matrixArray",
      "userProductResults",
      "productAnswersArray",
      "siteSettings",
      "likeliestProductsList"
    ]),
    multiAnswersIds() {
      return this.multiAnswers.map(answers => answers.answerIndex);
    }
  },
  methods: {
    ...mapActions(["storeAnsweredQuestion", "storeMultiAnsweredQuestion"]),
    async storeAnswers() {
      if(this.questionObject.type==="multi"){
        return await this.storeMultiAnsweredQuestion(this.multiAnswers);
      }else{
        return await this.storeAnsweredQuestion({
          questionId: this.questionObject.id,
          
        });
      }
    },
    async answeredQuestion({ answer, answerIndex }) {
      if (this.questionObject.type !== "multi") {
        return await this.storeAnsweredQuestion({
          questionId: this.questionObject.id,
          answerIndex,
          answer
        });
      }

      const multiAnswerIndex = this.multiAnswers.findIndex(mAnswer => {
        return mAnswer.answerIndex === answerIndex;
      });

      if (multiAnswerIndex > -1) {
        this.multiAnswers.splice(multiAnswerIndex, 1);
      } else {
        this.multiAnswers.push({
          questionId: this.questionObject.id,
          answerIndex,
          answer
        });
      }
    }
  },
  mounted() {
    //console.log(this.questionObject);
  }
};
</script>

<style lang="scss" scoped>
.step {
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: inherit;
  // justify-content: center;
}
.notice {
  color: red;
}
.doneIcon {
  width: 28px;
  cursor: pointer;
}
 button {
      padding: 10px;
      text-decoration: none;
      color: #fff;
      background-color: #08c;
      border: none;
      outline: none;
      font-size: 20px;
      text-align: center;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom:5px;
      cursor: pointer;
      &:disabled {
        opacity: 0.5;
      }
      span{
        margin-right: 3px;
      }
    }

</style>
